"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorSnackbar = ErrorSnackbar;
exports.InfoSnackbar = InfoSnackbar;
exports.SuccessSnackbar = SuccessSnackbar;
exports.WarningSnackbar = WarningSnackbar;
var _react = _interopRequireWildcard(require("react"));
var _Icons = require("./Icons");
var _material = require("@mui/material");
var _Alert = _interopRequireDefault(require("@mui/material/Alert"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Alert = /*#__PURE__*/_react["default"].forwardRef(function Alert(props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], Object.assign({
    elevation: 6,
    ref: ref,
    variant: "filled"
  }, props));
});
function GenericSnackbar(_ref) {
  var message = _ref.message,
    variant = _ref.variant,
    onClose = _ref.onClose,
    horizontal = _ref.horizontal,
    vertical = _ref.vertical;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClose = function handleClose(event, reason) {
    if (typeof onClose === 'function') {
      onClose();
    }
    setOpen(false);
  };
  (0, _react.useEffect)(function () {
    setOpen(!!message);
  }, [message]);
  return /*#__PURE__*/_react["default"].createElement(_material.Snackbar, {
    open: open,
    anchorOrigin: {
      vertical: vertical !== null && vertical !== void 0 ? vertical : 'bottom',
      horizontal: horizontal !== null && horizontal !== void 0 ? horizontal : 'right'
    },
    action: /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
      key: "close",
      "aria-label": "close",
      color: "inherit",
      onClick: handleClose
    }, /*#__PURE__*/_react["default"].createElement(_Icons.CloseIcon, {
      fontSize: "small"
    })),
    onClose: handleClose
  }, /*#__PURE__*/_react["default"].createElement(Alert, {
    onClose: handleClose,
    severity: variant,
    sx: {
      width: '100%'
    }
  }, message));
}
function ErrorSnackbar(props) {
  return /*#__PURE__*/_react["default"].createElement(GenericSnackbar, {
    variant: "error",
    message: props.message,
    onClose: props.onClose,
    horizontal: props.horizontal
  });
}
function SuccessSnackbar(props) {
  return /*#__PURE__*/_react["default"].createElement(GenericSnackbar, {
    variant: "success",
    message: props.message,
    onClose: props.onClose,
    horizontal: props.horizontal
  });
}
function WarningSnackbar(props) {
  return /*#__PURE__*/_react["default"].createElement(GenericSnackbar, {
    variant: "warning",
    message: props.message,
    onClose: props.onClose,
    horizontal: props.horizontal
  });
}
function InfoSnackbar(props) {
  return /*#__PURE__*/_react["default"].createElement(GenericSnackbar, {
    variant: "info",
    message: props.message,
    onClose: props.onClose,
    horizontal: props.horizontal
  });
}